import { createSlice } from '@reduxjs/toolkit'

export const CreateProjectAssetTypeSlice = createSlice(
  {
  name: 'asset_type_for_project_creation',
  initialState: {
    value: "",
  },
  reducers: {
    updateAssetType: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateAssetType } = CreateProjectAssetTypeSlice.actions

export default CreateProjectAssetTypeSlice.reducer